export default __webpack_public_path__ + "static/media/arug_01-3.95e28a9b.jpg";